import { map } from 'lodash';
import React from 'react';
import Select from 'react-select';
import FormikDateOfBirth from '../../../components/FormikDateOfBirth';

import './styles.scss';

function renderFieldGroup(targetProps = {}) {
  const {
    id,
    label,
    value,
    valueError,
    valueTouched,
    type,
    choices,
    infoText,
    maxLength,
    setFieldValue,
    disabled = false,
    size,
    ...otherProps
  } = targetProps;

  const showError = valueError && valueTouched;

  const inputClassName = `form-control ${showError ? ' is-invalid' : ''}`;

  let inputControl;

  if (type === 'select') {
    inputControl =
      size === 'mobile' ? (
        <div className="select-wrapper">
          <select
            className={inputClassName}
            id={id}
            name={id}
            value={value}
            type={type}
            disabled={disabled}
            {...otherProps}
          >
            {map(choices, (val, key) => {
              return <option value={key}>{`${val}`}</option>;
            })}
          </select>
        </div>
      ) : (
        <Select
          id={id}
          name={id}
          getStyles={() => ({
            multiValueLabel: {
              whiteSpace: 'normal'
            }
          })}
          value={value}
          cropWithEllipsis={false}
          options={choices}
          isDisabled={disabled}
          {...otherProps}
        />
      );
  } else if (type === 'date' && id === 'dateOfBirth') {
    inputControl = (
      <FormikDateOfBirth
        setFieldValue={setFieldValue}
        id={id}
        name={id}
        value={value}
        type={type}
        inputClassName={inputClassName}
        {...otherProps}
      />
    );
  } else {
    inputControl = (
      <input
        className={inputClassName}
        id={id}
        name={id}
        value={value}
        type={type}
        maxLength={maxLength}
        disabled={disabled}
        {...otherProps}
      />
    );
  }

  return type === 'checkbox' ? (
    <div
      className={`form-control-checkbox ${
        showError ? ' form-field-error' : ''
      }`}
      htmlFor={id}
    >
      {inputControl}
      <label>{label}</label>
    </div>
  ) : (
    <div className="form-group">
      <label
        className={`form-control-label${showError ? ' form-field-error' : ''}`}
        htmlFor={id}
      >
        {label}
      </label>
      {inputControl}
      {showError ? (
        <p
          className="invalid-feedback"
          style={showError && { display: 'block' }}
        >
          <small>{valueError}</small>
        </p>
      ) : (
        <p>
          <small>{infoText}</small>
        </p>
      )}
    </div>
  );
}

export default renderFieldGroup;
